export const CHATBOT_SCRIPT = "https://static.ada.support/embed2.js";
export const CHATBOT_ID = "__ada";
export const CHATBOT_DATA_HANDLE = "amway-ana-assistant";
